import React, { useState } from 'react'
import styled from 'styled-components'
import { HTMLInputTypeAttribute } from 'react'
import { icons } from '../shared-asstes/icons'
import { Input } from 'antd'

interface IInputProps {
  type: HTMLInputTypeAttribute
  value: any
  label: string
  placeholder: string
  id: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any
}

function PasswordInput({
  id,
  onChange,
  value,
  label,
  placeholder,
}: IInputProps) {
  const [passwordShow, setPassword] = useState(false)
  const iconStyle: any = {
    position: 'absolute',
    left: '1rem',
    top: '1rem',
    cursor: 'pointer',
    // display: value === "" ? "none" : "",
  }

  function IconClickHandler() {
    setPassword(!passwordShow)
  }

  return (
    <>
      <label htmlFor={id} className='label'>
        {label}
      </label>
      <PasswordContainer>
        <Input
          type={passwordShow ? 'text' : 'password'}
          id={id}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          required
          className='input'
        />
        {passwordShow ? (
          <img
            src={icons.PASSWORD_INVISIBLE}
            style={iconStyle}
            onClick={IconClickHandler}
          />
        ) : (
          <img
            src={icons.PASSWORD_VISIBLE}
            style={iconStyle}
            onClick={IconClickHandler}
          />
        )}
      </PasswordContainer>
    </>
  )
}

const PasswordContainer = styled.div<any>`
  position: relative;
  input[type='password']::-ms-reveal,
  input[type='password']::-ms-clear {
    display: none;
  }
`

export default PasswordInput
